 import img1 from "./images/illustration/fitness-img-1.jpg"
const Goal=()=>{
    return(
        <>
        <section className="container-fluid">
            <section className="container">
                <section className="row">

                    <div className="col-12 col-md-6">
                        <img src={img1} alt="" className="w-75" />
                    </div>

                    <div className="col-12 col-md-6 mt-5">
                        <h1>REACH YOUR BODY GOALS</h1>
                        <p>Convallis ullamcorper velit, varius maecenas viverra purus nunc. In  <br />
                        suscipit aliquet sociis nibh quis. Neque pellentesque habitant aliquet <br />
                         venenatis at est.</p>
                         <input type="text" class="form-control" placeholder="cardio Training" aria-label="cardio Training" className="w-75"/>  
                         <input type="text" class="form-control" placeholder="Basic Yoga" aria-label="Basic Yoga" className="w-75"/>
                         <input type="text" class="form-control" placeholder="Muscle  Training" aria-label="cardio Training" className="w-75"/>
                         <input type="text" class="form-control" placeholder="Stretching" aria-label="cardio Training" className="w-75"/>

            

                    </div>

                </section>
            </section>
        </section>
        </>
    );
}
export default Goal;